<template>
  <section>
    <PublicNavigation />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <h1>Supercharge your search <span>for IT professionals</span></h1>
      </div>
    </section>
    <!-- Main header end -->
    <!-- Recruitment section -->
    <section class="recruitment">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img
              class="img-fluid"
              src="../../../public/img/homepage/img-services.png"
              alt="services"
            />
            <button
              @click="handleClick"
              class="btn btn-secondary"
              style="display: block; width: 200px; padding: 12px; margin: 20px auto"
            >
              Request Proposal
            </button>
          </div>
          <div class="col-md-6">
            <h2>Recruitment, the modern way</h2>
            <p>
              We know what it takes to find the best talent and connect them with roles that fit
              their skills and professional goals. With our professional services, we combine the
              best from two worlds; our extensive network of IT professionals with our valued tech
              recruiters that personally approach suitable candidates for you.
            </p>
            <h3>Flexible, powerful and tailored search</h3>
            <p>
              Our experience in both the recruitment and IT industries allows us to offer models
              where we combine access to our modern web-based platform, with professional recruiting
              services.
            </p>
            <ul class="list-unstyled">
              <li class="first">These services include:</li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Composing job ads
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Headhunting (own and external databases)
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Social recruiting
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Advertising
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Initial screening
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                In-depth qualification
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                On-line programming tests for developers
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Arranging customer meetings
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Verifying references and other background checks
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                International search
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Obtaining/renewing working permits
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--End of recruitment -->

    <!--Benefits Section -->
    <section class="benefits">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto text-center">
            <h2>Benefits using recruitment services</h2>
            <p>
              You choose which of our professional services that you want to use to facilitate and
              boost your IT recruiting project. Headhunting can often make a hugh difference in
              particual for more senior roles and maybe you want our help with composing a really
              compelling job ad. Your position is always marketed via our portal and through our
              partner network, but we can also conduct a targeted social media campaign if you want.
              Lean back and let us help you to succeed with your tech recruitment projects.
            </p>
            <div class="row">
              <div class="col-md-4">
                <img
                  class="img-fluid"
                  src="../../../public/img/homepage/icon_resume_color.png"
                  alt="resume"
                />
                <h3>A bigger pool of talent</h3>
                <p>
                  More candidates means a better chance of finding the person most suited to your
                  needs.
                </p>
              </div>
              <div class="col-md-4">
                <img
                  class="img-fluid"
                  src="../../../public/img/homepage/icon_iterate_color.png"
                  alt="iterate"
                />
                <h3>Expertise at every step</h3>
                <p>
                  Our background in IT means that we can truly understand your requirements and help
                  you to succeed in your recruitment efforts.
                </p>
              </div>
              <div class="col-md-4">
                <img
                  class="img-fluid"
                  src="../../../public/img/homepage/icon_interview_color.png"
                  alt="interview"
                />
                <h3>Save time</h3>
                <p>
                  Our professional services and co-operative approach makes the recruitment process
                  smooth and efficient for you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Benefits -->
    <section class="mid-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              Seven tips on how to succeed in tech recruiting:<br />
              Navigating the Modern Work Landscape
            </h2>
            <p>
              Attracting the right IT talent is a daunting yet vital task for the growth of any tech
              company. The key to successful IT recruitment lies beyond just posting job ads; it
              requires a strategic approach to attract, engage, and retain top talent amid stiff
              competition. The best approach is often to combine different strategies based on the
              characteristics of each open position.
            </p>
            <p>
              This whitepaper unveils seven tips for succeeding in recruiting a high-performing tech
              team, offering insights into modern recruitment challenges and practical advice to
              enhance your hiring process. It's an essential read for anyone looking to refine their
              approach to tech recruiting.
            </p>
            <div class="mx-auto col-md-4">
              <a
                target="_blank"
                href="https://jobshark.eu/whitepapers/How_to_Recruit_Top_IT_Professionals.pdf"
                download="How to Recruit Top IT Professionals.pdf"
                class="btn btn-secondary"
                >Download Whitepaper</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--- Contact Us -->
    <section class="contact-us" ref="form">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>
              PLEASE DON’T HESITATE TO CONTACT US IF YOU WANT MORE INFORMATION ABOUT OUR RECRUITING
              SERVICES
            </h2>

            <form @submit.prevent="getCaptcha" id="recruiting-services-contact">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="name" class="sr-only">Name</label>
                  <input
                    v-model="name"
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Name"
                    required
                  />
                  <span>*</span>
                </div>
                <div class="form-group col-md-6">
                  <label for="email" class="sr-only">Email</label>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    required
                  />
                  <span>*</span>
                </div>
                <div class="form-group col-md-6">
                  <label for="company" class="sr-only">Compnay</label>
                  <input
                    v-model="company"
                    type="text"
                    class="form-control"
                    id="company"
                    placeholder="Company"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="phone" class="sr-only">Phone</label>
                  <input
                    v-model="phone"
                    type="phone"
                    class="form-control"
                    id="phone"
                    placeholder="Phone"
                  />
                </div>
                <div class="form-group col-md-12">
                  <label class="sr-only" for="comment">Message</label>
                  <textarea
                    v-model="message"
                    class="form-control"
                    rows="6"
                    required
                    id="comment"
                    placeholder="Message"
                  ></textarea>
                </div>
                <div class="col-md-4 mx-auto">
                  <button :disabled="isSending" type="submit" class="btn btn-secondary btn-block">
                    Contact Us
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- End Contact Us -->
    <!-- Footer -->
    <Footer />
    <!-- End Footer -->
  </section>
</template>

<script>
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import axios from 'axios';
import { required, email, integer, minLength } from 'vuelidate/lib/validators';
import titleMixin from '../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title: 'Recruiting Services | Jobshark',
  components: {
    PublicNavigation,
    Footer,
  },
  data: () => ({
    isLoading: true,
    isSending: false,
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    reToken: '',
    tracking_code: null,
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      name: {
        required,
        minLength: minLength(3),
      },
      company: {
        required,
      },
      phone: {
        required,
        integer,
      },
      message: {
        required,
        minLength: minLength(10),
      },
    },
  },
  methods: {
    getCaptcha() {
      this.isSending = true;
      let vm = this;
      const mailTo = () => this.sendMail();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          mailTo();
        });
    },
    sendMail() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/externalpages/contact`,
        data: {
          first_name: this.name,
          email: this.email,
          phone: this.phone,
          company: this.company,
          message: this.message,
          page: 'Recruiting Services',
          'g-recaptcha-response': this.reToken,
          tracking_code: this.tracking_code,
        },
      })
        .then(res => {
          this.$toasted.success('Thanks for contacting us. Your message was sent successfully!', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isSending = false;
        })
        .catch(err => {
          this.$toasted.error('Unfortunately, there was an a problem to send your message.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isSending = false;
        });
    },
    handleClick() {
      this.$refs.form.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    },
    submitContactUs() {},
  },
  mounted() {
    if (this.$route.query.utm_id) {
      this.tracking_code = this.$route.query.utm_id;
    }
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.container {
  max-width: 1320px;
}
h2 {
  text-transform: uppercase;
  font-size: 28px;
  margin-bottom: 15px;
}

p {
  color: #575757;
  font-size: 16px;
  font-family: $font-family-sans-lato;
}
.main-header {
  height: 70vh;
  background: url('../../../public/img/homepage/header-services.png');
  background-size: cover;
  margin-top: 70px;
  .container {
    height: 70vh;
    flex-wrap: wrap;
    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;
      span {
        display: block;
      }
    }
  }
}

.recruitment {
  padding: 60px 0;
  h3 {
    font-family: $font-family-sans-lato;
    font-weight: 700;
    font-size: 21px;
    color: #575757;
    margin: 20px 0 12px 0;
  }

  .list-unstyled {
    font-family: $font-family-sans-lato;
    color: #575757;
    li {
      margin: 0 0 6px 30px;
      display: flex;
      align-items: center;
      &.first {
        margin-left: 0;
        list-style-type: none;
      }
      .icon {
        margin-right: 10px;
      }
      i {
        color: #f26622;
        font-size: 14px;
      }
    }
  }
}

.benefits {
  padding: 30px 0;
  p {
    margin-bottom: 60px;
  }
  .col-md-4 {
    img {
      width: 75px;
      height: 75px;
      margin: 0 auto 18px auto;
    }
    h3 {
      text-transform: uppercase;
      color: #424242;
      font-size: 18px;
    }
  }
}

.mid-section {
  padding: 80px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
    position: relative;

    img {
      margin: -12px 10px 0 0;
    }
  }

  p {
    text-align: center;
    color: #fff;
  }

  .btn-secondary {
    background: #fff;
    border-color: #fff;
    margin: 50px auto 0 auto;
    padding: 8px 25px;
    display: block;
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }
}

.contact-us {
  h2 {
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
  form {
    margin: 50px 0;
    .form-group {
      position: relative;
      .form-control {
        border-radius: 8px;
        min-height: 65px;
        font-size: 18px;
        font-family: $font-family-sans-lato;
      }
      span {
        position: absolute;
        display: flex;
        top: 0;
        right: 0;
        padding: 0 25px 0 0;
        height: 100%;
        align-items: center;
        justify-content: center;
        font-size: 21px;
        color: red;
      }
    }
    .btn-secondary {
      padding: 15px 0;
      font-size: 18px;
      margin-top: 20px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .main-header {
    height: 50vh;
    .container {
      height: 50vh;
      padding: 30px 20px;
      h1 {
        font-size: 2rem;
      }
    }
  }
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
  }
}
@media only screen and (max-width: 576px) {
  .main-header {
    margin-top: 60px;
  }
}
</style>
